@if (ondOffers().length > 0) {
  <div class="mr-large-y">
    @if (heading(); as heading) {
      <h2 class="mr-small-b nordic-blue-900-text text-icon-primary font-headline-small">
        {{ heading }}
      </h2>
    }

    <div class="ond-marketing-offers grid-col-12">
      @for (ondOffer of ondOffers() | slice: 0 : offerAmount(); track $index; let i = $index) {
        <div
          class="ond-marketing-offer-tile flex flex--column border rounded grey-50-bg surface-disabled-bg pr-small animate-appear"
          [ngClass]="
            i + 1 > offerAmount() - moreOffersAmount ? 'animate-appear--' + (i - offerAmount() + moreOffersAmount) : ''
          "
        >
          <div class="flex-1">
            <div class="light-type ms-xxsmall-b font-body-medium">
              {{ ondOffer?.originLocationCode }} – {{ ondOffer?.destinationLocationCode }}
            </div>

            <div class="nordic-blue-900-text text-icon-primary bold-type ms-xxsmall-b font-headline-small">
              {{ ondOffer.originCityName }} -
              {{ ondOffer.destinationCityName }}
            </div>

            <div class="light-type mr-small-b font-body-small">
              {{ ondOffer?.departureDate | finDateFormat: 'FULL' }} –
              {{ ondOffer?.returnDate | finDateFormat: 'FULL' }}
            </div>

            <div class="mr-xsmall-b align-right">
              <div class="nordic-blue-900-text text-icon-primary light-type lowercase font-body-medium">
                {{ 'pricesStartingFrom' | finLocalization }}
              </div>

              <span class="heather-700-text text-icon-primary bold-type font-headline-medium">
                {{ ondOffer?.price | finPrice: { roundPrice: true } }}
              </span>
            </div>
          </div>

          @if (ondOffer.link) {
            <button
              (click)="navigateToUrl(ondOffer)"
              class="ond-marketing-offer-tile__link align-left nordic-blue-900-text text-icon-primary no-underline underline-hover font-body-medium-bold"
            >
              {{ 'bookNow' | finLocalization }}
              <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.ARROW_RIGHT" />
            </button>
          }
        </div>
      }
    </div>
  </div>
}

@if (ondOffers().length > offerAmount()) {
  <div class="align-center">
    <button class="btn bold-type" (click)="loadMoreOffers()">{{ 'ondMarketing.loadMore' | finLocalization }}</button>
  </div>
}
